// ModulosGrid.jsx
import { useNavigate } from 'react-router-dom';
import '../../pages/dashboard/dashboard.css'

const COLORES = [
  { bg: '#E6F1FB', color: '#185FA5' },
  { bg: '#EAF3DE', color: '#3B6D11' },
  { bg: '#FAEEDA', color: '#854F0B' },
  { bg: '#FBEAF0', color: '#993556' },
  { bg: '#EEEDFE', color: '#534AB7' },
  { bg: '#E1F5EE', color: '#0F6E56' },
];

export default function ModulosGrid({ modulos, tienePermiso }) {
  const navigate = useNavigate();

  const modulosVisibles = modulos.filter(item => {
    if (!item.modulo) return true;
    return tienePermiso(item.modulo, item.permiso);
  });

  return (
    <div className="modulos-container" style={{ width: '100%' }}>
      <p className="modulos-seccion-titulo">Acceso rápido</p>
      <div className="modulos-grid">
        {modulosVisibles.map((item, i) => {
          const { bg, color } = COLORES[i % COLORES.length];
          return (
            <button
              key={item.path}
              className="modulo-card"
              onClick={() => navigate(item.path)}
            >
              <span className="modulo-icono" style={{ background: bg, color }}>
                <i className={`pi pi-${item.icon}`} style={{ fontSize: 22 }} />
              </span>
              <span className="modulo-nombre">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}